import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface TermsModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function TermsModal({
  isOpen,
  onClose
}: TermsModalProps) {
  return <AnimatePresence data-id="element-205">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{
        backgroundColor: 'rgba(5,10,20,0.85)',
        backdropFilter: 'blur(6px)'
      }} data-id="element-206" />
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.3,
        ease: 'easeOut'
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 pointer-events-none" data-id="element-207">
            <div className="relative w-full max-w-2xl max-h-[80vh] overflow-y-auto rounded-2xl p-8 pointer-events-auto" style={{
          backgroundColor: '#0C1628',
          border: '1px solid rgba(14,165,233,0.2)',
          boxShadow: '0 0 80px rgba(14,165,233,0.1)'
        }} data-id="element-208">
              <button onClick={onClose} className="absolute top-5 right-5 p-2 rounded-full transition-colors" style={{
            color: '#475569',
            backgroundColor: 'rgba(14,165,233,0.06)'
          }} data-id="element-209">
                <X size={18} data-id="element-210" />
              </button>

              <h2 className="text-2xl font-black mb-1" style={{
            color: '#F1F5F9'
          }} data-id="element-211">
                Términos de Uso
              </h2>
              <p className="text-xs mb-8" style={{
            color: '#475569'
          }} data-id="element-212">
                Última actualización: febrero 2026
              </p>

              <div className="space-y-6 text-sm leading-relaxed" style={{
            color: '#94A3B8'
          }} data-id="element-213">
                <section data-id="element-214">
                  <h3 className="font-bold mb-2" style={{
                color: '#38BDF8'
              }} data-id="element-215">
                    1. Aceptación de los Términos
                  </h3>
                  <p data-id="element-216">
                    Al acceder y adquirir el producto digital "Arquitectos del
                    Futuro", aceptas quedar vinculado por estos Términos de Uso.
                    Si no estás de acuerdo con alguna parte de estos términos,
                    no debes proceder con la compra.
                  </p>
                </section>

                <section data-id="element-217">
                  <h3 className="font-bold mb-2" style={{
                color: '#38BDF8'
              }} data-id="element-218">
                    2. Descripción del Producto
                  </h3>
                  <p data-id="element-219">
                    "Arquitectos del Futuro" es una guía digital educativa
                    diseñada para padres hispanos en Estados Unidos que desean
                    preparar a sus hijos para el mercado laboral en la era de la
                    inteligencia artificial. El producto se entrega en formato
                    digital de acceso inmediato.
                  </p>
                </section>

                <section data-id="element-220">
                  <h3 className="font-bold mb-2" style={{
                color: '#38BDF8'
              }} data-id="element-221">
                    3. Licencia de Uso
                  </h3>
                  <p data-id="element-222">
                    Al adquirir este producto, se te otorga una licencia
                    personal, no exclusiva e intransferible para uso individual.
                    Queda estrictamente prohibido:
                  </p>
                  <ul className="list-disc list-inside mt-2 space-y-1 ml-2" data-id="element-223">
                    <li data-id="element-224">Reproducir, distribuir o revender el contenido</li>
                    <li data-id="element-225">Compartir el acceso con terceros</li>
                    <li data-id="element-226">
                      Usar el contenido con fines comerciales sin autorización
                      escrita
                    </li>
                    <li data-id="element-227">Modificar o crear obras derivadas del material</li>
                  </ul>
                </section>

                <section data-id="element-228">
                  <h3 className="font-bold mb-2" style={{
                color: '#38BDF8'
              }} data-id="element-229">
                    4. Política de Reembolso
                  </h3>
                  <p data-id="element-230">
                    Ofrecemos una garantía de satisfacción de 30 días. Si por
                    cualquier razón no estás satisfecho con el producto, puedes
                    solicitar un reembolso completo dentro de los 30 días
                    posteriores a la compra enviando un correo a nuestro equipo
                    de soporte. No se requiere justificación.
                  </p>
                </section>

                <section data-id="element-231">
                  <h3 className="font-bold mb-2" style={{
                color: '#38BDF8'
              }} data-id="element-232">
                    5. Limitación de Responsabilidad
                  </h3>
                  <p data-id="element-233">
                    El contenido de esta guía es de carácter educativo e
                    informativo. Los resultados pueden variar según cada familia
                    y contexto. No garantizamos resultados específicos. El autor
                    y la empresa no serán responsables por decisiones tomadas
                    basándose en el contenido de este material.
                  </p>
                </section>

                <section data-id="element-234">
                  <h3 className="font-bold mb-2" style={{
                color: '#38BDF8'
              }} data-id="element-235">
                    6. Propiedad Intelectual
                  </h3>
                  <p data-id="element-236">
                    Todo el contenido, incluyendo textos, imágenes, gráficos y
                    diseño, es propiedad exclusiva de Arquitectos del Futuro y
                    está protegido por las leyes de derechos de autor
                    aplicables.
                  </p>
                </section>

                <section data-id="element-237">
                  <h3 className="font-bold mb-2" style={{
                color: '#38BDF8'
              }} data-id="element-238">
                    7. Modificaciones
                  </h3>
                  <p data-id="element-239">
                    Nos reservamos el derecho de modificar estos términos en
                    cualquier momento. Los cambios entrarán en vigor al
                    publicarse en esta página. El uso continuado del producto
                    constituye aceptación de los términos modificados.
                  </p>
                </section>

                <section data-id="element-240">
                  <h3 className="font-bold mb-2" style={{
                color: '#38BDF8'
              }} data-id="element-241">
                    8. Contacto
                  </h3>
                  <p data-id="element-242">
                    Para cualquier consulta sobre estos términos, puedes
                    contactarnos en:{' '}
                    <span style={{
                  color: '#38BDF8'
                }} data-id="element-243">
                      soporte@arquitectosdelfuturo.com
                    </span>
                  </p>
                </section>
              </div>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}